export default {
  buttons: {
    back: 'Înapoi',
  },
};
